/**
 * Finds out if the current browser supports going into fullscreen.
 */
export const fullscreenAvailable = () => (
  document.body.requestFullscreen ||
  document.body.webkitRequestFullscreen ||
  document.body.mozRequestFullScreen ||
  document.body.msRequestFullscreen
);

/**
 * Places the provided DOM element in full screen.
 * @param fullscreenElement
 */
export const requestFullscreenHelper = (fullscreenElement) => {
  if (fullscreenElement.requestFullscreen) {
    fullscreenElement.requestFullscreen();
  } else if (fullscreenElement.webkitRequestFullscreen) {
    fullscreenElement.webkitRequestFullscreen();
  } else if (fullscreenElement.mozRequestFullScreen) {
    fullscreenElement.mozRequestFullScreen();
  } else if (fullscreenElement.msRequestFullscreen) {
    fullscreenElement.msRequestFullscreen();
  }
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/fullscreen.js